/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import { IEligibilityStatusApiClient } from './contracts'
import { injectable } from 'inversify'
import { IEligibilityStatus } from '../RequestHistoryStateManager/contracts'

@injectable()
export class MockEligibilityStatusApiClient implements IEligibilityStatusApiClient {
	getAllEligibilityStatuses(): Promise<IEligibilityStatus[]> {
		return new Promise<IEligibilityStatus[]>(resolve =>
			resolve([
				{ id: 1, name: 'Pending', isSelected: false },
				{ id: 2, name: 'Complete', isSelected: false },
				{ id: 3, name: 'Error', isSelected: false },
				{ id: 4, name: 'Timed Out', isSelected: false },
			]),
		)
	}
}
